module.exports = __webpack_public_path__ + "img/6f87c6d.jpg";